import React from 'react'
import { arrayArea } from '../../helpers/area'
import { arrayModalidade } from '../../helpers/modalidade'
import { jobs } from '../../types/components/jobs'
import { ButtonSend } from '../ButtonSend'
import { Select } from '../Select'
import * as S from './styles'

export type FiltersSearchProps = React.FC<{
  typeFilter?: 'user' | 'admin'
  jobsArray: jobs[]
  area: string | undefined
  setArea: React.Dispatch<React.SetStateAction<string | undefined>>
  place: string | undefined
  setPlace: React.Dispatch<React.SetStateAction<string | undefined>>
  office: string | undefined
  setOffice: React.Dispatch<React.SetStateAction<string | undefined>>
  modality: string | undefined
  setModality: React.Dispatch<React.SetStateAction<string | undefined>>
}>

export const FiltersSearch: FiltersSearchProps = ({
  typeFilter = 'admin',
  jobsArray,
  area,
  setArea,
  place,
  setPlace,
  office,
  setOffice,
  modality,
  setModality
}) => {
  const handleCleanFilter = () => {
    setArea('')
    setPlace('')
    setOffice('')
    setModality('')
  }
  const arrayLocal = jobsArray && jobsArray.map(item => item.Local)
  const arrayLocalFilter =
    arrayLocal &&
    arrayLocal.filter(function (item, index) {
      return arrayLocal.indexOf(item) === index
    })
  const arrayCargoAdmin = jobsArray && jobsArray.map(item => item.Cargo)
  const arrayCargoAdminFilter =
    arrayCargoAdmin &&
    arrayCargoAdmin
      .filter(function (item, index) {
        return arrayCargoAdmin.indexOf(item) === index
      })
      .sort()
  const arrayCargoUser =
    jobsArray &&
    jobsArray
      .map(item => {
        let cargo
        if (item.IsActive) {
          cargo = item.Cargo
        }
        return cargo as string
      })
      .filter(item => {
        return item !== ''
      })
      .sort()
  const arrayCargoUserFilter =
    arrayCargoUser &&
    arrayCargoUser.filter(function (item, index) {
      return arrayCargoUser.indexOf(item) === index
    })

  return (
    <S.Container>
      <S.Title>Filtros</S.Title>
      <S.Wrapper>
        <Select
          text="Cargo"
          array={
            typeFilter === 'admin'
              ? arrayCargoAdminFilter && arrayCargoAdminFilter
              : arrayCargoUserFilter && arrayCargoUserFilter
          }
          value={office as string}
          handleChange={e => setOffice(e.target.value)}
          widthDiv="22%"
        />
        <Select
          text="Area"
          array={arrayArea}
          value={area as string}
          handleChange={e => setArea(e.target.value)}
          widthDiv="22%"
        />
        <Select
          text="Local"
          array={arrayLocalFilter && arrayLocalFilter.sort()}
          value={place as string}
          handleChange={e => setPlace(e.target.value)}
          widthDiv="22%"
        />
        <Select
          text="Modalidade"
          array={arrayModalidade}
          value={modality as string}
          handleChange={e => setModality(e.target.value)}
          widthDiv="22%"
        />
        <ButtonSend color="error" nameButton="Limpar" onClick={handleCleanFilter} widthButton="10%" />
      </S.Wrapper>
    </S.Container>
  )
}
